import React from "react";
import { component_tool, utils_tool } from '@/tool';
import { WizTableForm } from '@/containers/common';
import moment from "moment";
import '@/styles/containers/train/credit/subjectcreditrecord/index.less'

let { $$, checkStrLength } = utils_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const organizationBrandConfig = WizTableForm.Config.dealer(this, { apiParams: { state: 1, organizationNodeCategory: 2 } })

let { WizDataTable, WizIcon, WizButton, WizDivider, WizRow, WizCol, WizInputNumber, WizPopover } = component_tool

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })

export const personColumns = (self, employees, other) => {
  let oper = []
  let btns = (self.getMenuBtn() || []).map((btn) => { return btn['code'] })
  if (btns.indexOf('update') !== -1 && btns.indexOf('enableOrDisable') !== -1) {
    oper.push(
      {
        title: '操作',
        tableItem: {
          width: 150,
          fixed: 'right',
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton type="link" onClick={e => self.openModel(record)}>编辑</WizButton>
              <WizButton type="link" onClick={e => self.updateState(record)}>{record.state == 1 ? '禁用' : '启用'}</WizButton>
            </WizDataTable.Oper>
          )
        }
      }
    )
  } else {
    if (btns.indexOf('update') !== -1) {
      oper.push(
        {
          title: '操作',
          tableItem: {
            width: 80,
            fixed: 'right',
            render: (text, record) => (
              <WizDataTable.Oper>
                <WizButton type="link" onClick={e => self.openModel(record)}>编辑</WizButton>
              </WizDataTable.Oper>
            )
          }
        }
      )
    } else if (btns.indexOf('enableOrDisable') !== -1) {
      oper.push(
        {
          title: '操作',
          tableItem: {
            width: 80,
            fixed: 'right',
            render: (text, record) => (
              <WizDataTable.Oper>
                <WizButton type="link" onClick={e => self.updateState(record)}>{record.state == 1 ? '禁用' : '启用'}</WizButton>
              </WizDataTable.Oper>
            )
          }
        }
      )
    }
  }

  let columns = [
    {
      title: 'id',
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'subjectId',
      name: 'subjectId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'entityId',
      name: 'entityId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {},
      searchItem: {
        initialValue: other && other.userName
      }
    },
    {
      title: '姓名',
      name: 'fullName',
      searchItem: {
        initialValue: other && other.fullName
      },
      tableItem: {}
    },
    {
      title: '账号状态',
      name: 'accountState',
      searchItem: {
        type: 'select',
        initialValue: other && other.accountState
      },
      tableItem: {},
      dict: [
        { code: 0, codeName: '禁用' },
        { code: 1, codeName: '激活' },
      ],
    },
    {
      title: '任职',
      name: 'userIdentityInfos',
      tableItem: {
        // ellipsis: true,
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p key={index}>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if (contextList && contextList.length > 1) {
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: '岗位',
      name: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm
      }
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm
      },
      formItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio'
      }
    },
    {
      title: '分数',
      searchItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow className={'credit-subject-row-item'}>
              <WizCol span={10}>
                {
                  getFieldDecorator('scoreStart', {
                    initialValue: other && other.scoreStart
                  })(
                    <WizInputNumber placeholder={'请输入'} precision={2} min={0} />
                  )
                }
              </WizCol>
              <WizCol className='col-item-center' span={4}>至</WizCol>
              <WizCol span={10}>
                {
                  getFieldDecorator('scoreEnd', {})(
                    <WizInputNumber placeholder={'请输入'} precision={2} min={0} />
                  )
                }
              </WizCol>
            </WizRow>
          )
        },
      },
    },
    {
      title: '分数',
      name: 'score',
      tableItem: {},
      formItem: {}
    },
    {
      title: '获得时间',
      name: 'gainTime',
      tableItem: {
        render: (text, record) => {
          const { gainTime } = record;
          return formatterDate(gainTime)
        }
      },
    },
    {
      title: '获得途径',
      name: 'channel',
      tableItem: {
        // ellipsis: true,
      },
    },
    {
      title: '数据来源',
      name: 'dataSource',
      tableItem: {},
      dict: [
        { code: 0, codeName: '人工导入' },
        { code: 1, codeName: '系统生成' }
      ],
    },
    {
      title: "状态",
      name: "state",
      dict: [
        { code: 0, codeName: '无效' },
        { code: 1, codeName: '有效' }
      ],
      searchItem: {
        type: 'select',
        initialValue: other && other.state
      },
      tableItem: {},
    },
    {
      title: '最新修改时间',
      name: 'updateTime',
      tableItem: {
        render: (text, record) => {
          const { updateTime } = record;
          return formatterDateTime(updateTime)
        }
      },
    },
    {
      title: '获得时间',
      name: 'gainTime',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
        showTime: false,
      },
    },
    ...oper
  ];

  return columns;
}

export const dealerColumns = (self, employees, other) => {
  let columns = [
    {
      title: 'id',
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'subjectId',
      name: 'subjectId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'entityId',
      name: 'entityId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '经销商名称',
      name: 'dealerName',
      tableItem: {
        // ellipsis: true,
      },
      searchItem: {
        initialValue: other && other.dealerName
      }
    },
    {
      title: '销售代码',
      name: 'preSalesNumber',
      searchItem: {
        initialValue: other && other.preSalesNumber
      },
      tableItem: {}
    },
    {
      title: '售后代码',
      name: 'afterSalesNumber',
      searchItem: {
        initialValue: other && other.afterSalesNumber
      },
      tableItem: {}
    },
    {
      title: '品牌',
      name: 'brandId',
      searchItem: {
        ...organizationBrandConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '品牌',
      name: 'brandName',
      tableItem: {},
      formItem: {}
    },
    {
      title: '开店状态',
      name: 'dealerState',
      tableItem: {},
      searchItem: {
        type: 'select',
        initialValue: other && other.afterSalesNumber
      },
      formItem: {},
      dict: [
        { code: 0, codeName: '已关店' },
        { code: 1, codeName: '已开店' },
        { code: 2, codeName: '建设中' },
      ],
    },
    {
      title: '分数',
      searchItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow className={'credit-subject-row-item'}>
              <WizCol span={10}>
                {
                  getFieldDecorator('scoreStart', {})(
                    <WizInputNumber placeholder={'请输入'} precision={2} min={0} />
                  )
                }
              </WizCol>
              <WizCol className='col-item-center' span={4}>至</WizCol>
              <WizCol span={10}>
                {
                  getFieldDecorator('scoreEnd', {})(
                    <WizInputNumber placeholder={'请输入'} precision={2} min={0} />
                  )
                }
              </WizCol>
            </WizRow>
          )
        },
      },
    },
    {
      title: '分数',
      name: 'score',
      tableItem: {},
      formItem: {}
    },
    {
      title: '获得时间',
      name: 'gainTime',
      tableItem: {
        render: (text, record) => {
          const { gainTime } = record;
          return formatterDate(gainTime)
        }
      },
    },
    {
      title: '获得途径',
      name: 'channel',
      tableItem: {
        // ellipsis: true,
      },
    },
    {
      title: '数据来源',
      name: 'dataSource',
      tableItem: {},
      dict: [
        { code: 0, codeName: '人工导入' },
        { code: 1, codeName: '系统生成' }
      ],
    },
    {
      title: "状态",
      name: "state",
      dict: [
        { code: 0, codeName: '无效' },
        { code: 1, codeName: '有效' }
      ],
      searchItem: {
        type: 'select',
        initialValue: other && other.state
      },
      tableItem: {},
    },
    {
      title: '最新修改时间',
      name: 'updateTime',
      tableItem: {
        render: (text, record) => {
          const { updateTime } = record;
          return formatterDateTime(updateTime)
        }
      },
    },
    {
      title: '获得时间',
      name: 'gainTime',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
        showTime: false,
      },
    },
    {
      title: '操作',
      tableItem: {
        width: 150,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton type="link" onClick={e => self.openDealerModel(record)}>编辑</WizButton>
            <WizButton type="link" onClick={e => self.updateState(record)}>{record.state == 1 ? '禁用' : '启用'}</WizButton>
          </WizDataTable.Oper>
        )
      }
    }
  ];

  return columns;
}


export const personExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '姓名',
    field: 'fullName',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '账号',
    field: 'userName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '身份证号/工号',
    field: 'idCard',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '手机号',
    field: 'mobile',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '用户属性',
    field: 'userTypeName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '账号状态',
    field: 'userStatusName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '所属科目',
    field: 'subjectName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '分数',
    field: 'score',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '获得时间',
    field: 'gainTimeStr',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '获得途径',
    field: 'channel',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '状态',
    field: 'stateName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '数据来源',
    field: 'dataSourceName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '创建时间',
    field: 'createTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '最新修改时间',
    field: 'updateTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  }
];

export const dealerExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '经销商名称',
    field: 'dealerName',
    width: 35,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '销售代码',
    field: 'preSalesNumber',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '售后代码',
    field: 'afterSalesNumber',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '品牌',
    field: 'brandName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '区域',
    field: 'areaName',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '开店状态',
    field: 'dealerStateName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '所属科目',
    field: 'subjectName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '分数',
    field: 'score',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '获得时间',
    field: 'gainTimeStr',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '获得途径',
    field: 'channel',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '状态',
    field: 'stateName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '数据来源',
    field: 'dataSourceName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '创建时间',
    field: 'createTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '最新修改时间',
    field: 'updateTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  }
]
